var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/systemuser/erstellen"}},[_vm._v("Benutzer Erstellen")]),_vm._v(" "),_c('v-table',{staticClass:"customer-list-table",attrs:{"url":"/api/v1/user","filter":_vm.filter,"appends":['delete_url'],"row-classes":{
      'table-disabled': function (model) {
        return Boolean(model.disabled_at);
      },
      'table-deleted': function (model) {
        return Boolean(model.deleted_at);
      },
      'table-deletion': function (model) {
        return Boolean(model.deletion_at);
      }
    },"attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'name',
        name: 'Name',
        type: 'SystemUserNameCell'
      },
      {
        attribute: 'email',
        name: 'E-Mail-Adresse'
      },
      {
        attribute: 'created_at',
        name: 'Registrierdatum'
      },
      {
        attribute: 'roles',
        name: 'Rollen',
        type: 'RolesCell',
        sortable: false
      },
      {
        attribute: 'permissions',
        name: 'Permissions',
        type: 'PermissionsCell',
        sortable: false
      },
      {
        attribute: 'id',
        name: 'Aktionen',
        type: 'SystemUserActionCell',
        sortable: false
      }
    ]},scopedSlots:_vm._u([{key:"filter",fn:function(){return [_c('table-filter',{attrs:{"filterComponents":[
          {
            type: 'TakeFilter',
            name: 'take'
          },
          {
            type: 'WhereFilter',
            label: 'ID',
            attributes: 'id'
          },
          {
            type: 'WhereLikeFilter',
            label: 'E-Mail-Adresse',
            attributes: 'email'
          },
          {
            type: 'WhereLikeFilter',
            label: 'Name',
            attributes: 'name'
          },
          {
            type: 'DateFilter',
            label: 'Registrierdatum von',
            attributes: { column: 'created_at', operator: '>=' }
          },
          {
            type: 'DateFilter',
            label: 'Registrierdatum bis',
            attributes: { column: 'created_at', operator: '<=' }
          },
          {
            type: 'RoleFilter'
          },
          {
            type: 'PermissionFilter'
          }
        ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }